import React, { Component } from 'react';
import Dialog from '../../../../../commonModules/interface/Dialog';
import Photos from '../../../../../commonModules/interface/input-files';
import { isEmpty } from "lodash";
import Select from 'react-select'
import Form from 'react-jsonschema-form';
import { Button, Box } from '@material-ui/core';
import { TextArea, InputSelect, InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';
import PopUp from '../../../../../commonModules/interface/PopUp';

class TechAnalys extends Component {
    state = { 
        step: 1,
        errors:{
            comments: "",
            formID: "",
            next_status: ""
        }
    }
    nextStep = () => {
        this.setState({step : this.state.step + 1})
    }
    submitJsonForm = (data) => {
        console.log('====================================');
        console.log({data}, data.formData);
        console.log('====================================');
        this.props.submitForm(data.formData)
        this.nextStep()
    }
    validate = () => {
        const { step } = this.state;
        if (step === 1){

            if (this.props.comments !== "") {
                this.setState({
                    errors:{
                        ...this.state.errors,
                        comments:""
                    }
                })
                this.nextStep()
            } else {
                this.setState({
                    errors:{
                        ...this.state.errors,
                        comments:"Veuillez remplir ce champ"
                    }
                })
    
            }
        } else if (step === 3) {
            if (this.props.next_status !== "") {
                this.setState({
                    errors:{
                        ...this.state.errors,
                        next_status:""
                    }
                })
                this.props.submitAll()
            } else {
                this.setState({
                    errors:{
                        ...this.state.errors,
                        next_status:"Veuillez remplir ce champ"
                    }
                })
    
            }
        }
    }
    render() {
        const { step } = this.state;
        const formList = []
        if(!isEmpty(this.props.SAV_SCHEMAS)){
            Object.values(this.props.SAV_SCHEMAS).map(schema => {
                formList.push({value: schema.id, label:schema.name})
            })
        }
        return (
            <PopUp
                title="Analyse Technique du produit"
                close={this.props.closeForms}
                maxWidth="md"
                submitAction={step !== 2 && this.validate}
                // submitTitle="Suivant"
            >
                <Box>
                    {step === 1 &&
                    <div>
                        <TextArea
                            placeholder="Achat de piéce, test technique ..." 
                            rows={4}
                            value={this.state.comments} 
                            name="comments" 
                            onChange={this.props.handleChange}
                            title="Description détaillée"
                            error={this.state.errors.comments}
                            required
                        />
                        {/* <div className={"form-group " + (this.state.errors.comments ? "has-error" : "") }>
                            <label htmlFor="comments" className="control-label">Description détaillée *</label>
                            <div className="fg-line ">      
                                <textarea 
                                    className="form-control auto-size" 
                                    placeholder="Problèmes défauts ..." 
                                    rows={4}
                                    value={this.props.comments} 
                                    name="comments" 
                                    onChange={this.props.handleChange} 
                                ></textarea>
                                <small className="help-block">{this.state.errors.comments}</small>
                            </div>
                        </div> */}
                        {/* <Button color="secondary" variant="contained" onClick={this.validate} >Suivant</Button> */}
                    </div>
                    }
                    {step === 2 &&
                        <div>
                            <InputSelectMagasin
                                options={formList}
                                value={this.props.formID_display}
                                onChange={ option => this.props.handleSelect(option,"formID")}
                                // isOptionDisabled={ option => option.disabled === true}
                                required
                                label="Questionnaire"
                                error={this.state.errors.formID}
                            />    

                            {/* <div className={"form-group " + (this.state.errors.formID ? "has-error" : "") }>
                                <label htmlFor="formID" className="control-label">Questionnaire *</label>
                                <small className="help-block">{this.state.errors.formID}</small>
                            </div> */}
        
                            
                            {this.props.formID && 
                                <DisplayForm ID={this.props.formID} submitForm={this.submitJsonForm} />
                            }
                        </div>
                    }
                    {step === 3 &&
                        <div>
                            <InputSelectMagasin
                                options={[
                                    {value:"IN_REPAIR", label:"Réparable"},
                                    {value:"REPAIRED", label:"Réparé"},
                                    {value:"HS", label:"Irréparable"},
                                ]}
                                value={this.props.next_status_display}
                                onChange={ option => this.props.handleSelect(option,"next_status")}
                                // isOptionDisabled={ option => option.disabled === true}
                                error={this.state.errors.next_status}
                                label="Etat après analyse"
                                required
                            />    
                            {/* <div className={"form-group " + (this.state.errors.next_status ? "has-error" : "") }>
                                <label htmlFor="next_status" className="control-label"> *</label>
                                <small className="help-block">{this.state.errors.next_status}</small>
                            </div> */}
                            
                            <Box p={1}>
                                {/* <h5> <span>Joindre Fichier(s)</span> </h5> */}
                                <Photos photoList={this.props.setFiles} photos={this.props.files === null ? [] : this.props.files } file/>
                            </Box>
                        
                            {/* <Button color="secondary" variant="contained" onClick={this.validate} >Valider</Button> */}
                                
                        </div>
                    }


                </Box>
            </PopUp>
        );
    }
}

export default TechAnalys;

class DisplayForm extends React.Component {
    state = {
        form:{
            uiSchema:{},
            jsonSchema:{},
        },
    }
    componentDidMount= async() => {
        console.log("CDM DisplayForm");
        try {
            const infos = await fetch('/schema/get?idSchema='+this.props.ID,{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            let body = await infos.json();

            if(body.error){
                console.log("[ERROR] error get Schemas", body);  
                return false
            } else {
                console.log('====================================');
                console.log({body});
                console.log('====================================');
                this.setState({
                    form:{
                        uiSchema:JSON.parse(body.uiSchema),
                        jsonSchema:JSON.parse(body.jsonSchema),
                    },
                    schemaID:body.schemaID,
                })
                return true
            }
        } catch (e) {
            console.log(e);
            return false
        }  
    }
    render(){
        console.log('====================================');
        console.log("[STATE]DisplayForm render", this.state);
        console.log('====================================');
        return (
            <div>
                
                {this.state.form.uiSchema && 
                    <Form
                        schema={this.state.form.jsonSchema}
                        uiSchema={this.state.form.uiSchema}
                        onSubmit={this.props.submitForm}
                    >
                            <Button variant="contained" color="secondary" type="submit">
                                Valider
                            </Button>
                    </Form>
                }
            </div>
        )
    }
}